import React from 'react';
import { Chip, TableCell } from '@mui/material';

interface HighAvailabilityCellProps {
  isHighAvailability: boolean;
}

export const HighAvailabilityCell: React.FC<HighAvailabilityCellProps> = ({
  isHighAvailability,
}) => {
  return (
    <TableCell style={{ minWidth: 120 }} align="left">
      {isHighAvailability ? (
        <Chip label="Yes" color="success" />
      ) : (
        <Chip label="No" color="error" />
      )}
    </TableCell>
  );
};
